import { lazy, createElement as rc, Suspense } from 'react';
import Text from '../Text';

//Lazy load just in case camera stuff loads slow
export default function CameraProxy(props) {
    // avoid warning for dynamic import (which seems to need the extension)
    // eslint-disable-next-line import/extensions
    const Camera = lazy(() => import('./CameraInner.js'));
    const fallback = rc(Text, null, 'Loading...');
    // prettier-ignore
    return rc(Suspense, {fallback},
        rc(Camera, props)
    );
}
